import { useQuery } from 'react-query';

import { api } from '~/api';

export const useDigitalSoilTest = (lawnUuid) => {
  const {
    isLoading,
    error,
    data: digitalSoilTest,
  } = useQuery(
    'digitalSoilTest',
    () => api.lawns.fetchDigitalSoilTest(lawnUuid),
    {
      enabled: Boolean(lawnUuid),
    }
  );

  return {
    digitalSoilTest,
    isLoading,
    error,
  };
};
